import { useState } from 'react';
import { Search, Settings } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../../services/settings.service';
import { SearchIntegrationForm } from './SearchIntegrationForm';

export function SearchIntegrationCard() {
  const [showForm, setShowForm] = useState(false);

  const { data: searchConfig } = useQuery({
    queryKey: ['settings', 'search'],
    queryFn: () => settingsService.getSearch(),
  });

  const configuredCount =
    (searchConfig?.hasBraveKey ? 1 : 0) + (searchConfig?.hasSerperKey ? 1 : 0);
  const isConfigured = configuredCount > 0;

  return (
    <>
      <div className="bg-white rounded-xl border border-secondary-200 p-5 hover:shadow-sm transition-shadow">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            <div
              className={`w-2.5 h-2.5 rounded-full ${
                isConfigured ? 'bg-green-500' : 'bg-secondary-300'
              }`}
            />
            <div>
              <h3 className="font-semibold text-secondary-900">Busca (Skool)</h3>
              <p className="text-xs text-secondary-500">
                Chaves de Brave Search e Serper, cifradas no banco
              </p>
            </div>
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={() => setShowForm(true)}
              className="p-2 rounded-lg hover:bg-secondary-100 text-secondary-500"
            >
              <Settings className="w-4 h-4" />
            </button>
          </div>
        </div>

        {isConfigured ? (
          <div className="text-sm text-secondary-600 space-y-1">
            <p>Brave: {searchConfig?.hasBraveKey ? 'configurada' : 'não configurada'}</p>
            <p>Serper: {searchConfig?.hasSerperKey ? 'configurada' : 'não configurada'}</p>
          </div>
        ) : (
          <div className="flex items-center gap-2 mt-2 text-sm text-secondary-400">
            <Search className="w-4 h-4" />
            <span>Nenhuma chave configurada — clique na engrenagem para conectar</span>
          </div>
        )}
      </div>

      {showForm && <SearchIntegrationForm onClose={() => setShowForm(false)} />}
    </>
  );
}
